// import _ from 'lodash';
import {
  format,
  formatISO,
  startOfDay,
  startOfMonth,
  endOfMonth,
  setHours,
  differenceInDays,
  addDays,
  subDays,
  getYear,
  getMonth,
  getDate,
  getHours,
} from 'date-fns';

const defaultStartTimeHour = 12;
const defaultEndTimeHour = 14;

const minStartTimeNextDateHour = 0;
const maxStartTimeNextDateHour = 4;

export default {
  methods: {
    defaultScheduleTemplateItem() {
      const newScheduleTemplateItem = {
        programTitle: null,
        coverImage: null,
        coverImageCustom: null,
        programId: null,
        program: null,
        contentCategory: null,
        overrideProgramProperties: false,
        features: {
          audioDesc: false,
          restrictedLicense: false,
          soundtrack: false,
          closedCaptions: false,
          signLanguage: false,
        },
        broadcastingChannels: {
          facebook: false,
          tv: false,
          twitter: false,
          web: false,
          youtube: false,
        },
        startTime: null,
        endTime: null,
        isRerun: false,
        recurrentDaysOfWeek: [],
      };

      return {
        ...newScheduleTemplateItem,
        startTime: `${defaultStartTimeHour}:00`,
        endTime: `${defaultEndTimeHour}:00`,
      };
    },
    defaultScheduleItem(scheduleDate) {
      const newScheduleItem = {
        programTitle: null,
        episodeTitle: null,
        coverImage: null,
        coverImageCustom: null,
        programId: null,
        episodeId: null,
        program: null,
        episode: null,
        contentCategory: null,
        tagline: null,
        taglineCustom: null,
        features: {
          audioDesc: false,
          restrictedLicense: false,
          soundtrack: false,
          closedCaptions: false,
          signLanguage: false,
        },
        broadcastingChannels: {
          facebook: false,
          tv: false,
          twitter: false,
          web: false,
          youtube: false,
        },
        startTime: null,
        endTime: null,
        isRerun: false,
      };

      return {
        ...newScheduleItem,
        ...this.generateScheduleTime(scheduleDate), // generate startTime / EndTime
      };
    },
    formatScheduleTimeWithoutTimezone(timeString) {
      if (timeString) {
        const time = timeString.split(/[:]/);
        if (time[0] && time[1]) {
          return `${time[0]}:${time[1]}`;
        }
      }
      return '';
    },
    formatScheduleTime(date) {
      return formatISO(new Date(date), { representation: 'time' });
    },
    formatScheduleDate(selectDate) {
      return format(new Date(selectDate), 'yyyy/M/d');
    },
    getToday() {
      const today = new Date();
      return {
        date: parseInt(format(today, 'd'), 10),
        month: parseInt(format(today, 'M'), 10),
        year: parseInt(format(today, 'yyyy'), 10),
      };
    },
    transformDateToParams(scheduleDate) {
      const month = parseInt(getMonth(new Date(scheduleDate)), 10);
      return {
        scheduleYear: getYear(new Date(scheduleDate)),
        scheduleMonth: (month + 1),
        scheduleDate: getDate(new Date(scheduleDate)),
      };
    },
    transformParamsToDate({ scheduleYear, scheduleMonth, scheduleDate }) {
      if (scheduleYear && scheduleMonth && scheduleDate) {
        const month = Number(scheduleMonth) - 1; // indexOf month start from 0;
        return formatISO(startOfDay(new Date(scheduleYear, month, scheduleDate)));
      }
      return formatISO(startOfDay(new Date()));
    },
    getStartDayOfCalendar(startDayOfMonth) {
      const amountDayOfWeek = 7;
      const dayOfWeek = startDayOfMonth.getDay();
      if (dayOfWeek < amountDayOfWeek) {
        return subDays(new Date(startDayOfMonth), dayOfWeek + 1);
      }

      return startDayOfMonth;
    },
    getEndDayOfCalendar(startDayOfMonth) {
      const amountDayOfWeek = 7;
      const dayOfWeek = startDayOfMonth.getDay();
      if (dayOfWeek < amountDayOfWeek) {
        return subDays(new Date(startDayOfMonth), dayOfWeek + 1);
      }

      return startDayOfMonth;
    },
    getAmountOfSlot(startDayOfCalendar, endDayOfCalendar) {
      const diff = differenceInDays(endDayOfCalendar, startDayOfCalendar);
      const amountDayOfWeek = 7;
      const slotOfWeek = Math.ceil((diff / amountDayOfWeek));
      return slotOfWeek * amountDayOfWeek;
    },
    generateDayOfCalendarMonth(selectMonth) {
      const startDayOfMonth = startOfMonth(new Date(selectMonth));
      const startDayOfCalendar = this.getStartDayOfCalendar(startDayOfMonth);
      const endDayOfCalendar = endOfMonth(new Date(selectMonth));
      const amounthOfSlot = this.getAmountOfSlot(startDayOfCalendar, endDayOfCalendar);
      const dayList = [];

      for (let i = 0; i < amounthOfSlot; i += 1) {
        dayList.push(addDays(new Date(startDayOfCalendar), i + 1));
      }

      return dayList;
    },
    generateScheduleTime(scheduleDate) {
      const startTime = setHours(new Date(scheduleDate), defaultStartTimeHour);
      const endTime = setHours(new Date(scheduleDate), defaultEndTimeHour);
      return {
        startTime: formatISO(new Date(startTime)),
        endTime: formatISO(new Date(endTime)),
      };
    },
    splitStringToGetTime(hourString) {
      const elem = hourString.split(/[:]/);
      return {
        hour: elem[0],
        minute: elem[1],
      };
    },
    mappingHourToTime({ startTime, endTime }) {
      const date = startOfDay(new Date());
      const startTimeObject = this.splitStringToGetTime(startTime);
      const endTimeObject = this.splitStringToGetTime(endTime);

      return {
        startTime: new Date(date.getFullYear(), date.getMonth(), date.getDate(),
          startTimeObject.hour, startTimeObject.minute),
        endTime: new Date(date.getFullYear(), date.getMonth(), date.getDate(),
          endTimeObject.hour, endTimeObject.minute),
      };
    },
    isInPeriod(time, startHour, endHour) {
      return time >= startHour && time < endHour;
    },
    mappingScheduleTime(scheduleDate, startTime, endTime) {
      const tomorrow = new Date(scheduleDate);
      tomorrow.setDate(tomorrow.getDate() + 1);

      const startHour = getHours(startTime);
      const isNewDayTime = this.isInPeriod(startHour, minStartTimeNextDateHour, maxStartTimeNextDateHour);

      // Before Midnight -> After Midnight
      if (isNewDayTime && (startTime < tomorrow)) {
        return {
          startTime: addDays(startTime, 1),
          endTime: addDays(endTime, 1),
        };
      }
      // After Midnight -> Before Midnight
      if (!isNewDayTime && (startTime > tomorrow)) {
        return {
          startTime: addDays(startTime, -1),
          endTime: addDays(endTime, -1),
        };
      }

      return {
        startTime: new Date(startTime),
        endTime: new Date(endTime),
      };
    },
  },
};
